import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=5c958865&scoped=true"
import script from "./complete.vue?vue&type=script&lang=js"
export * from "./complete.vue?vue&type=script&lang=js"
import style0 from "./complete.vue?vue&type=style&index=0&id=5c958865&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c958865",
  null
  
)

export default component.exports